import { ArchiveResource } from "@skinsoft/types";
import { dbCacheUp } from "../dexie/cache-up";
import { OfflineDataUpdateCacher } from "..";

// @ts-ignore
export class ArchiveOfflineDataUpdateCacher extends OfflineDataUpdateCacher<ArchiveResource> {
    constructor() {
        super(dbCacheUp.archive)
    }
}